//@ts-nocheck
import cloudinary from "cloudinary-core";
const { Cloudinary } = cloudinary;

export const useCloudinary = () => {
	const cld = new Cloudinary({
		cloud_name: "djbs",
		secure: true,
	});

	return cld;
};
